import React from "react";
import { CompositeDecorator } from "draft-js";
import ReactResizeDetector from "react-resize-detector";

var resizeTimeout = null;

function findUserInputEntities(contentBlock, callback, contentState) {
  contentBlock.findEntityRanges((character) => {
    const entityKey = character.getEntity();
    return (
      entityKey !== null &&
      contentState.getEntity(entityKey).getType() === "USER_INPUT"
    );
  }, callback);
}
function findUserImages(contentBlock, callback, contentState) {
  contentBlock.findEntityRanges((character) => {
    const entityKey = character.getEntity();

    return (
      entityKey !== null &&
      contentState.getEntity(entityKey).getType() === "USER_IMAGE"
    );
  }, callback);
}

function findUserLinks(contentBlock, callback, contentState) {
  contentBlock.findEntityRanges((character) => {
    const entityKey = character.getEntity();

    return (
      entityKey !== null &&
      contentState.getEntity(entityKey).getType() === "USER_LINK"
    );
  }, callback);
}

class UserInput extends React.Component {
  defaultParams = {
    text: {
      minWidth: "32px",
      minHeight: "24px",
      maxWidth: "100%",
      maxHeight: "200px",
      resize: "both",
    },
    select: {
      minWidth: "32px",
      minHeight: "24px",
      maxWidth: "100%",
      resize: "horizontal",
    },
    check: {
      minWidth: "26px",
      minHeight: "24px",
      maxWidth: "100%",
      maxHeight: "200px",
      resize: "both",
    },
  };

  resizeInterval = 2000;

  onResize = (w, h) => {
    let width = w;
    let height = h;
    let { contentState, entityKey } = this.props;
    contentState.mergeEntityData(entityKey, {
      width,
      height,
      isResizing: true,
    });

    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(() => this.onResizeEnd(), this.resizeInterval);
  };

  onResizeEnd = () => {
    this.resizeTimeout = null;
    let { contentState, entityKey } = this.props;
    contentState.mergeEntityData(entityKey, {
      isResizing: false,
    });
  };

  render() {
    let { contentState, entityKey } = this.props;
    this.entity = contentState.getEntity(entityKey);
    let entityData = this.entity.getData() || {};

    let entityParams = Object.assign(
      this.defaultParams[entityData.kind],
      entityData
    );

    let userInput = null;

    if (entityParams.kind === "text") {
      userInput = (
        <div className="editor-entity-input">{entityParams.name}</div>
      );
    }

    if (entityParams.kind === "select") {
      userInput = (
        <div className="editor-entity-select">
          <span>{entityParams.name}</span>
          <span className="fa fa-caret-down"></span>
        </div>
      );
    }

    if (entityParams.kind === "check") {
      let list = entityParams.list || [];
      userInput = (
        <>
          {list.map((listItem, index) => {
            const item = listItem || {};
            return (
              <div key={index} className="editor-entity-check">
                <span
                  className={`fa ${
                    item.default ? "fa-check-square" : "fa-square-o"
                  }`}
                ></span>
                {item.name}
              </div>
            );
          })}
        </>
      );
    }

    let entityContainerClasses = ["entity-align"];
    let symbolStyles = this.props.children[0].props.styleSet.toJS();
    if (symbolStyles.includes("RIGHT"))
      entityContainerClasses.push("entity-align-right");
    if (symbolStyles.includes("LEFT"))
      entityContainerClasses.push("entity-align-left");
    if (symbolStyles.includes("CENTER"))
      entityContainerClasses.push("entity-align-center");

    return (
      <>
        <div className={entityContainerClasses.join(" ")}>
          <div
            data-entity={this.props.entityKey}
            style={{ ...entityParams }}
            className={`editor-entity editor-entity-block`}
          >
            <ReactResizeDetector
              skipOnMount
              handleWidth
              handleHeight
              onResize={this.onResize}
            />
            {this.props.children}
            <div className="editor-entity-container ">
              {userInput}
              <div
                data-entity={this.props.entityKey}
                className="editor-entity-block-overlay"
              ></div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

class UserImage extends React.Component {
  resizeInterval = 2000;

  onResize = (w, h) => {
    let width = w;
    let height = h;
    let { contentState, entityKey } = this.props;
    contentState.mergeEntityData(entityKey, {
      width,
      height,
      isResizing: true,
    });

    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(() => this.onResizeEnd(), this.resizeInterval);
  };

  onResizeEnd = () => {
    this.resizeTimeout = null;
    let { contentState, entityKey } = this.props;
    contentState.mergeEntityData(entityKey, {
      isResizing: false,
    });
  };

  render() {
    let { contentState, entityKey } = this.props;
    this.entity = contentState.getEntity(entityKey);
    let entityData = this.entity.getData() || {};

    let entityParams = Object.assign({}, entityData);

    let entityContainerClasses = ["entity-align"];
    let symbolStyles = this.props.children[0].props.styleSet.toJS();
    if (symbolStyles.includes("RIGHT"))
      entityContainerClasses.push("entity-align-right");
    if (symbolStyles.includes("LEFT"))
      entityContainerClasses.push("entity-align-left");
    if (symbolStyles.includes("CENTER"))
      entityContainerClasses.push("entity-align-center");
    if (entityParams.float === "right")
      entityContainerClasses.push("entity-float-right");
    if (entityParams.float === "left")
      entityContainerClasses.push("entity-float-left");

    return (
      <>
        <div className={entityContainerClasses.join(" ")}>
          <div
            data-entity={this.props.entityKey}
            style={{ ...entityParams }}
            className={`editor-entity editor-entity-image float-${entityParams.float}`}
          >
            <ReactResizeDetector
              skipOnMount
              handleWidth
              handleHeight
              onResize={this.onResize}
            />
            {this.props.children}
            <img
              data-entity={this.props.entityKey}
              alt=""
              src={entityParams.image}
            />
          </div>
        </div>
      </>
    );
  }
}

class UserLink extends React.Component {
  render() {
    let { contentState, entityKey } = this.props;
    this.entity = contentState.getEntity(entityKey);

    return (
      <>
        <span data-entity={entityKey} className="editor-entity-link">
          {this.props.children}
        </span>
      </>
    );
  }
}

export const decorator = new CompositeDecorator([
  {
    strategy: findUserInputEntities,
    component: UserInput,
  },
  {
    strategy: findUserImages,
    component: UserImage,
  },
  {
    strategy: findUserLinks,
    component: UserLink,
  },
]);
